<template>
	<div id="app">
		<SiteHeader></SiteHeader>

		<section
			id="quiz-sec"
			class="d-flex flex-column justify-content-center"
		>
			<div>
				<h5 id="app-title" v-if="this.appConfig.title">
					{{ this.appConfig.title }}
				</h5>

				<!-- {{ currentStepIndex }} -->

				<div class="quiz-inr-box">
					<div
						id="app-progress"
						class="row app-row justify-content-center"
					>
						<ul class="progress-list">
							<li
								class="s1"
								v-bind:class="{
									active: currentStepIndex >= 0,
									current: currentStepIndex == 0,
								}"
							>
								<p>Home Owner</p>
							</li>
							<li
								class="s2"
								v-bind:class="{
									active: currentStepIndex >= 1,
									current: currentStepIndex == 1,
								}"
							>
								<p>Property Type</p>
							</li>
							<li
								class="s3"
								v-bind:class="{
									active: currentStepIndex >= 2,
									current: currentStepIndex == 2,
								}"
							>
								<p>Insurance</p>
							</li>
							<li
								class="s4"
								v-bind:class="{
									active: currentStepIndex >= 3,
									current: currentStepIndex == 3,
								}"
							>
								<p>Year</p>
							</li>
							<li
								class="s5"
								v-bind:class="{
									active: currentStepIndex >= 4,
									current: currentStepIndex == 4,
								}"
							>
								<p>Date</p>
							</li>
							<li
								class="s6"
								v-bind:class="{
									active: currentStepIndex == 5,
									current: currentStepIndex == 5,
								}"
							>
								<p>Final Questions</p>
							</li>
						</ul>
						<div id="progress" class="align-self-center">
							<div
								class="progressbar"
								role="progressbar"
								v-bind:style="
									'width: ' + percentageComplete + '%'
								"
								v-bind:aria-valuenow="percentageComplete"
								aria-valuemin="0"
								aria-valuemax="100"
							>
								<img
									src="/img/house-icon.png"
									class="heart-progress"
								/>
							</div>
						</div>
					</div>

					<div
						id="app-step"
						ref="appStep"
						class="row app-row step-row justify-content-center"
						v-on:scroll="updateScrollableAndScrolledToEnd"
					>
						<div class="app-step-wrapper">
							<div class="col-12 align-self-top p-0">
								<input
									id="leadid_token"
									ref="jornayaId"
									name="universal_leadid"
									type="hidden"
									value=""
								/>
								<input
									id="trustedform_id"
									ref="trustedformId"
									name="trustedform_id"
									type="hidden"
									value=""
								/>
								<input
									id="trustedform_url"
									ref="trustedformUrl"
									name="trustedform_url"
									type="hidden"
									value=""
								/>
								<step
									v-bind:appState="appState"
									v-bind:lead="lead"
									v-bind:eventBus="eventBus"
									v-on:loading="onLoading"
									v-on:complete="saveLead"
									v-on:stepComplete="onStepComplete"
									v-on:preStepTransition="onPreStepTransition"
									v-on:postStepTransition="
										onPostStepTransition
									"
								></step>
							</div>
							<div
								id="app-step-scroll-indicator"
								ref="appStepScrollIndicator"
								class="col-12 align-self-top"
								v-bind:class="{
									'visibility-hidden':
										!scrollable || scrolledToEnd || loading,
								}"
							>
								<div id="app-step-scroll-indicator-background">
									&#9660;
								</div>
							</div>

							<div
								id="back"
								v-bind:class="{
									'visibility-hidden':
										currentStepIndex <= 0 ||
										submittedLead ||
										loading ||
										lead.message,
								}"
							>
								<button
									class="btn-back"
									v-on:click="goToPreviousStep"
								>
									<span>Previous</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<InsuranceProviders></InsuranceProviders>

		<SiteFooter></SiteFooter>
	</div>
</template>

<script>
import { steps, stepValues } from "./steps.js";
import { typeValues } from "./types.js";
import { v4 as uuidv4 } from "uuid";

import Vue from "vue";
import Step from "./Step.vue";
import { utils } from "./utils.js";

import SiteHeader from "./components/partials/Header.vue";
import InsuranceProviders from "./components/partials/InsuranceProviders.vue";
import SiteFooter from "./components/partials/Footer.vue";

function getNewLead() {
	return {
		id: uuidv4(),
		insuranceType: null,
		autoInsurance: {
			insuranceLengthInMonths: null,
			currentInsurer: null,
			currentInsurerLengthInMonths: null,
			requestedCoverageType: null,
			numberOfDrivers: null,
			pendingVehicles: [],
			vehicles: [utils.getNewVehicle()],
			licenseStatus: null,
			accidentsOrTicketsInPast3Years: null,
			numberOfAccidentsInPast3Years: null,
			numberOfTicketsInPast3Years: null,
			dui: null,
			needsSr22: null,
			isInterestedInHomeOrRentersInsuranceQuotes: null,
		},
		homeInsurance: {
			homeType: null,
			ownHome: null,
			dateHomeBought: null,
			homeOccupancyType: null,
			homeSecuritySystemType: null,
			anyClaimsInPast5Years: null,
			currentInsurer: null,
			currentDeductible: null,
			currentLiability: null,
		},
		creditRating: null,
		isMarried: null,
		currentResidenceType: null,
		currentResidenceLengthInMonths: null,
		gender: null,
		dateOfBirthDay: "",
		dateOfBirthMonth: "",
		dateOfBirthYear: "",
		isInMilitary: null,
		streetAddress: null,
		city: null,
		state: "",
		zipCode: null,
		firstName: null,
		lastName: null,
		email: null,
		phoneNumber: null
	};
}

export default {
	name: "app",
	components: {
		Step,
		SiteHeader,
		InsuranceProviders,
		SiteFooter,
	},
	created: function() {
		this.checkForQueryParameters();

		// load lead from local storage
		this.loadLeadFromLocalStorage();

		// prevent route changes while submitting lead
		this.$router.beforeEach((to, from, next) => {
			if (
				from &&
				from.path &&
				from.path.indexOf("PhoneNumber") >= 0 &&
				this.submittingLead
			) {
				this.utils.log("preventing route change while submitting lead");
				next(false);
			} else if (from && from.path && from.path.indexOf("Message") >= 0) {
				this.utils.log(
					"preventing route change while displaying message"
				);
				next(false);
			} else if (this.loading) {
				this.utils.log("preventing route change while loading");
				next(false);
			} else {
				next();
			}
		});
	},
	mounted: function () {
		this.updateScrollableAndScrolledToEnd();
		window.addEventListener(
			"resize",
			this.updateScrollableAndScrolledToEnd
		);
	},
	data: function () {
		return {
			steps: steps,
			stepValues: stepValues,
			typeValues: typeValues,
			lead: getNewLead(),
			eventBus: new Vue(),
			appState: {
				makeModelTrimsByYear: {},
				submitted: false,
				submittedSuccessfully: false,
				messageTitle: null,
				message: null
			},
			landingPage: null,
			subId: null,
			subId2: null,
			subId3: null,
			subId4: null,
			subId5: null,
			startTime: new Date(),
			scrollable: false,
			scrolledToEnd: false,
			submittingLead: false,
			submittedLead: false,
			loading: false,
		};
	},
	methods: {
		checkForQueryParameters: function () {
			var params = new URLSearchParams(window.location.search);

			// zip code
			var zipCode =
				params.get("zipCode") ||
				params.get("ZipCode") ||
				params.get("zipcode");

			if (zipCode && zipCode.length == 5) {
				this.lead.zipCode = zipCode;
				this.utils.log("loaded zipCode " + zipCode);
			}

			// landing page
			var landingPage = params.get("landingPage") || params.get("LandingPage") || params.get("landingpage");

			if (landingPage) {

				if (!landingPage.startsWith("/")) {
					landingPage = "/" + landingPage;
				}

				this.landingPage = landingPage;
				this.utils.log("loading landing page " + landingPage);
			}

			// sub ids
			var subId =
				params.get("subId") ||
				params.get("SubId") ||
				params.get("subid");

			if (subId) {
				this.subId = subId;
				this.utils.log("loaded sub id " + subId);
			}

			var subId2 =
				params.get("subId2") ||
				params.get("SubId2") ||
				params.get("subid2");

			if (subId2) {
				this.subId2 = subId2;
				this.utils.log("loaded sub id 2 " + subId2);
			}

			var subId3 =
				params.get("subId3") ||
				params.get("SubId3") ||
				params.get("subid3");

			if (subId3) {
				this.subId3 = subId3;
				this.utils.log("loaded sub id 3 " + subId3);
			}

			var subId4 =
				params.get("subId4") ||
				params.get("SubId4") ||
				params.get("subid4");

			if (subId4) {
				this.subId4 = subId4;
				this.utils.log("loaded sub id 4 " + subId4);
			}

			var subId5 =
				params.get("subId5") ||
				params.get("SubId5") ||
				params.get("subid5");

			if (subId5) {
				this.subId5 = subId5;
				this.utils.log("loaded sub id 5 " + subId5);
			}
		},
		updateScrollableAndScrolledToEnd: function () {
			var appStep = this.$refs.appStep;
			if (!appStep) {
				return;
			}

			this.scrollable = appStep.scrollHeight > appStep.clientHeight;
			this.scrolledToEnd =
				appStep.scrollTop + appStep.clientHeight >
				appStep.scrollHeight - 20;
		},
		goToPreviousStep: function () {
			this.eventBus.$emit("goToPreviousStep");
		},
		goToStep: function (step) {
			this.eventBus.$emit("goToStep", step);
		},
		onStepComplete: function () {
			this.persistLeadToLocalStorage();
		},
		onPreStepTransition: function () {
			// reset scrollbar
			this.$refs.appStep.scrollTop = 0;
		},
		onPostStepTransition: function () {
			this.updateScrollableAndScrolledToEnd();
		},
		clearLead: function () {
			this.lead = getNewLead();
			this.utils.log("reset lead");
			localStorage.removeItem("lead-data");
			localStorage.removeItem("lead-last-update-time");
			this.utils.log("removed old lead from localStorage");
		},
		logLead: function () {
			this.utils.log(JSON.stringify(this.lead));
		},
		logApiLead: function () {
			var apiLead = this.getApiLead();
			this.utils.log(JSON.stringify(apiLead));
		},
		logMediaAlphaLead: function () {
			this.mediaAlphaUtils.getDataQueryStringParameterValue(
				this.startTime,
				this.lead,
				this.$refs.jornayaId,
				this.appConfig.tcpaText
			);
		},
		logVisiquaLead: function () {
			this.visiquaUtils.getDataQueryStringParameterValue(this.lead);
		},
		loadLeadFromLocalStorage: function () {
			if (typeof Storage !== "undefined") {
				try {
					// check expiration
					var leadLastUpdateTime = localStorage.getItem(
						"lead-last-update-time"
					);

					if (leadLastUpdateTime) {
						var currentTime = new Date().getTime();

						// within expiration time
						if (currentTime - leadLastUpdateTime < this.appConfig.localStorageExpirationInMilliseconds) {
							this.lead = JSON.parse(localStorage.getItem("lead-data"));
							this.appState.submitted = false;
							this.utils.log("loaded lead from localStorage");
						} else {
							localStorage.removeItem("lead-data");
							localStorage.removeItem("lead-last-update-time");
							this.utils.log(
								"removed old lead from localStorage"
							);
						}
					}
				} catch (e) {
					this.clearSavedLead();
					this.utils.log(e);
				}
			}
		},
		persistLeadToLocalStorage: function () {
			if (typeof Storage !== "undefined") {
				try {
					const json = JSON.stringify(this.lead);
					localStorage.setItem("lead-data", json);
					localStorage.setItem(
						"lead-last-update-time",
						new Date().getTime()
					);
					this.utils.log("persisted lead to localStorage");
				} catch (e) {
					this.utils.log("error persisting lead to localStorage");
					this.utils.log(e);
					this.clearSavedLead();
				}
			}
		},
		onLoading: function (loading) {
			this.utils.log("loading: " + loading);
			this.loading = loading;
		},
		saveLead: function (retryAttempt) {
			if (!this.submittingLead) {
				this.submittedLead = true;
				this.submittingLead = true;
				var apiLead = this.getApiLead();
				this.utils.log("saving lead");
				this.utils.log(apiLead);

				var vm = this;

				this.axios
					.post("/Api/Widget/SaveLead", apiLead)
					.then(function (response) {
						vm.utils.log("saved lead");
						vm.utils.log(response);
						vm.redirect(true, response.data);
					})
					.catch(function (error) {
						var errorMessage = "error saving lead";

						if (error.response) {
							errorMessage +=
								" - status " + error.response.status;
						} else if (error.request) {
							errorMessage +=
								" - no response (" + error.request.status + ")";
						} else {
							errorMessage += " - error " + error.message;
						}

						vm.utils.log(errorMessage);
						vm.utils.log(error);

						try {
							vm.$gtag.event(errorMessage, {
								event_category: "App",
								event_label: vm.lead.id,
							});
						} catch (e) {
							vm.utils.log(e);
						}

						// retry save
						vm.utils.log("retry: " + retryAttempt);
						if (!retryAttempt) {
							vm.$gtag.event("retry saving lead", {
								event_category: "App",
								event_label: vm.lead.id,
							});
							vm.submittingLead = false;
							vm.saveLead(true);
						} else {
							vm.redirect(false);
						}
					});
			} else {
				this.utils.log("lead is already being submitted");
			}
		},
		redirect: function (success, responseData) {
			if (success && responseData) {
				var url = "";

				// override - short form
				if (
					responseData.LeadType === "ShortForm" &&
					this.appConfig.redirectUrlOverrideShortForm
				) {
					url = this.appConfig.redirectUrlOverrideShortForm;
				}
				// override
				else if (this.appConfig.redirectUrlOverride) {
					url = this.appConfig.redirectUrlOverride;
				}
				// redirect URL
				else if (responseData.Redirect && responseData.Redirect.RedirectUrl) {
					url = responseData.Redirect.RedirectUrl;
				}
				// redirect page
				else if (responseData.Redirect && responseData.Redirect.RedirectPage && this.appConfig.redirectUrlBase) {
					url = this.appConfig.redirectUrlBase + responseData.Redirect.RedirectPage;
				}
				// default
				else {
					url = this.appConfig.redirectUrlDefault;
				}

				url = url + "?id=" + this.lead.id;

				if (responseData.AnuraResult) {
					url = url + "&anuraResult=" + responseData.AnuraResult;
				}

				if (this.subId) {
					url = url + "&subId=" + this.subId;
				}

				if (this.subId2) {
					url = url + "&subId2=" + this.subId2;
				}

				if (this.subId3) {
					url = url + "&subId3=" + this.subId3;
				}

				var clickListingType = this.appConfig.clickListingTypeOverride;

				if (!clickListingType &&
					responseData.Redirect &&
					responseData.Redirect.ClickListingType
				) {
					clickListingType = responseData.Redirect.ClickListingType;
				}
				this.utils.log("click listing type: " + clickListingType);

				if (clickListingType) {
					switch (clickListingType) {
						case "MediaAlpha":
							var dataQueryStringParameter =
								this.mediaAlphaUtils.getDataQueryStringParameterValue(
									this.startTime,
									this.lead,
									this.$refs.jornayaId,
									this.appConfig.tcpaText
								);

							if (dataQueryStringParameter) {
								url = url + "&data=" + dataQueryStringParameter;
							}
							break;
						case "Visiqua":
							var dataQueryStringParameterVisiqua =
								this.visiquaUtils.getDataQueryStringParameterValue(
									this.lead
								);

							if (dataQueryStringParameterVisiqua) {
								url =
									url +
									"&data=" +
									dataQueryStringParameterVisiqua;
							}
							break;
						case "Transparently":
							url = url + "&t=T";
							break;
						case "InsideResponse":
							url = url + "&t=I";
							break;
					}
				}

				this.$gtag.event("redirect", {
					event_category: "App",
					event_label: this.lead.id,
					value: url,
				});
				this.utils.log("redirect url: " + url);

				this.submittingLead = false;
				this.appState.submitted = true;
				this.appState.submittedSuccessfully = true;

				if (!url) {
					return;
				}

				if (this.appConfig.debug) {
					if (confirm("Redirect to " + url)) {
						window.location.replace(url);
					}
				} else {
					window.location.replace(url);
				}
			} else {
				this.$gtag.event("redirect", {
					event_category: "App",
					event_label: this.lead.id,
					value: url,
				});
				this.utils.log("redirect url: " + url);

				this.submittingLead = false;
				this.appState.submitted = true;
				this.appState.submittedSuccessfully = false;

				if (this.appConfig.redirectUrlDefault) {
					window.location.replace(this.appConfig.redirectUrlDefault);
				}
			}
		},
		getApiLead: function () {
			var anuraId = null;
			var anuraVariable = window.AnuraVariable;

			if (anuraVariable && typeof anuraVariable === "object") {
				var anuraResponse = anuraVariable.getAnura();

				this.utils.log("checking for anura response");
				this.utils.log(anuraVariable);
				this.utils.log(anuraResponse);

				anuraId = anuraResponse.getId();
			}

			var autoInsurance = null;
			var homeInsurance = null;

			switch (this.currentType) {
				case typeValues.Auto:
					autoInsurance = {
						IsInsured:
							this.lead.autoInsurance.insuranceLengthInMonths > 0,
						InsuranceLengthInMonths:
							this.lead.autoInsurance.insuranceLengthInMonths > 0
								? this.lead.autoInsurance
										.insuranceLengthInMonths
								: null,
						CurrentInsurer: this.lead.autoInsurance.currentInsurer,
						CurrentInsurerLengthInMonths:
							this.lead.autoInsurance
								.currentInsurerLengthInMonths,
						RequestedCoverageType:
							this.lead.autoInsurance.requestedCoverageType,
						NumberOfDrivers:
							this.lead.autoInsurance.numberOfDrivers,
						Vehicles: this.lead.autoInsurance.vehicles,
						LicenseStatus: this.lead.autoInsurance.licenseStatus,
						AccidentsOrTicketsInPast3Years:
							this.lead.autoInsurance
								.accidentsOrTicketsInPast3Years,
						NumberOfAccidentsInPast3Years:
							this.lead.autoInsurance
								.numberOfAccidentsInPast3Years,
						NumberOfTicketsInPast3Years:
							this.lead.autoInsurance.numberOfTicketsInPast3Years,
						Dui: this.lead.autoInsurance.dui,
						NeedsSr22: this.lead.autoInsurance.needsSr22,
					};
					break;
				case typeValues.Home:
				case typeValues.Short:
					homeInsurance = {
						HomeType: this.lead.homeInsurance.homeType,
						OwnHome: this.lead.homeInsurance.ownHome,
						DateHomeBought: this.lead.homeInsurance.dateHomeBought,
						HomeOccupancyType:
							this.lead.homeInsurance.homeOccupancyType,
						HomeSecuritySystemType:
							this.lead.homeInsurance.homeSecuritySystemType,
						AnyClaimsInPast5Years:
							this.lead.homeInsurance.anyClaimsInPast5Years,
						CurrentInsurer: this.lead.homeInsurance.currentInsurer,
						CurrentDeductible:
							this.lead.homeInsurance.currentDeductible,
						CurrentLiability:
							this.lead.homeInsurance.currentLiability,
					};
					break;
			}

			return {
				ApiKey: this.appConfig.apiKey,
				LeadSource: {
					Id: this.lead.id,
					LeadCampaignId: this.getLeadCampaignId(),
					Source: this.appConfig.siteId,
					SubSource: this.subId ? this.subId : this.appConfig.subId,
					SubSource2: this.subId2,
					SubSource3: this.subId3,
					SubSource4: this.subId4,
					SubSource5: this.subId5,
					TcpaText: this.appConfig.tcpaText,
					Url: this.getUrl(),
					JornayaId: this.$refs.jornayaId ? this.$refs.jornayaId.value : null,
					TrustedFormCertificateUrl: this.$refs.trustedformUrl && this.$refs.trustedformUrl.value ? this.$refs.trustedformUrl.value :
						this.$refs.trustedformId && this.$refs.trustedformId.value ? "https://cert.trustedform.com/" + this.$refs.trustedformId.value : null,
					AnuraId: anuraId
				},
				InsuranceType: this.getInsuranceType(),
				AutoInsurance: autoInsurance,
				HomeInsurance: homeInsurance,
				CreditRating: this.lead.creditRating,
				IsMarried: this.lead.isMarried,
				CurrentResidenceType: this.lead.currentResidenceType,
				CurrentResidenceLengthInMonths:
					this.lead.currentResidenceLengthInMonths,
				IsInterestedInHomeOrRentersInsuranceQuotes:
					this.lead.isInterestedInHomeOrRentersInsuranceQuotes,
				Gender: this.lead.gender,
				DateOfBirth: this.getDateOfBirth(),
				IsInMilitary: this.lead.isInMilitary,
				StreetAddress: this.lead.streetAddress,
				City: this.lead.city,
				State: this.lead.state,
				ZipCode: this.lead.zipCode,
				FirstName: this.lead.firstName,
				LastName: this.lead.lastName,
				Email: this.lead.email,
				PhoneNumber: this.lead.phoneNumber,
			};
		},
		getLeadCampaignId: function () {
			switch (this.currentType) {
				case typeValues.Auto:
					return this.appConfig.autoLeadCampaignId;
				case typeValues.Home:
				case typeValues.Short:
					return this.appConfig.homeLeadCampaignId;
				default:
					return this.appConfig.autoLeadCampaignId;
			}
		},
		getUrl: function() {
			if (this.landingPage) {
				return document.location.protocol + "//" + document.location.hostname + this.landingPage;
			}

			if (document.referrer) {
				return document.referrer;
			}

			return document.location.protocol + "//" + document.location.hostname + document.location.pathname;
		},
		getInsuranceType: function() {
			switch (this.currentType) {
				case typeValues.Auto:
					return "AutoInsurance";
				case typeValues.Home:
				case typeValues.Short:
					return "HomeInsurance";
				default:
					return "AutoInsurance";
			}
		},
		getDateOfBirth: function () {
			return (
				this.lead.dateOfBirthYear +
				"-" +
				this.lead.dateOfBirthMonth +
				"-" +
				this.lead.dateOfBirthDay
			);
		},
	},
	computed: {
		currentStep: function () {
			return this.$route.path.split("/")[2];
		},
		currentStepIndex: function () {
			return steps[this.currentType].indexOf(this.currentStep);
		},
		currentType: function () {
			return this.$route.path.split("/")[1];
		},
		percentageComplete: function () {
			if (this.currentStepIndex == 0) {
				return 8;
			} else if (this.currentStepIndex == 1) {
				return 25;
			} else if (this.currentStepIndex == 2) {
				return 42;
			} else if (this.currentStepIndex == 3) {
				return 58;
			} else if (this.currentStepIndex == 4) {
				return 75;
			} else {
				return 91;
			}
		},
	},
};
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/fonts/fonts.css";

#app {
	background-color: transparent;
}

#app-debug {
	flex: 0 0 auto;
}

#app-title {
	flex: 0 0 auto;
}

#app-buttons {
	flex: 0 0 auto;
}

#app-progress {
	flex: 0 0 auto;
	padding: 0 50px 25px;
}

#app-step {
}

.app-step-wrapper {
	padding: 20px 20px 40px;
	width: 100%;
}

#app-step-scroll-indicator {
	position: absolute;
	bottom: 0;
	width: 66.6666% !important;
	font-size: 20px;
	pointer-events: none;
	margin: 0 !important;
	padding-left: 20px;
	padding-right: 20px;
}

#app-step-scroll-indicator-background {
	background: linear-gradient(
		to top,
		rgba(21, 110, 211, 1),
		rgba(21, 110, 211, 0)
	);
	height: 100%;
	width: 100%;
	text-align: center;
}

#progress {
	width: 100%;
	padding: 0;
}

.step-title {
	float: left;
	width: 100%;
	text-align: center;
	font-size: 29px;
	line-height: 34px;
	font-weight: 600;
	color: #003459;
	font-family: "Maison Neue Demi";
	letter-spacing: 0.5px;
	margin-bottom: 30px;
}

.step-content {
	width: 100%;
	margin: 25px 0;
}

.visibility-hidden {
	visibility: hidden;
}

.select-max-width {
	max-width: 175px;
	margin: 0.5rem !important;
}

.debug-component {
	margin: 0.25rem !important;
}

.app-row {
	max-width: 910px;
	margin: 0.25rem auto !important;
	width: 100% !important;
}

.step-row {
	flex: auto;
	width: 100% !important;
}

.progress {
	margin-bottom: 0;
}

.progress-bar {
	background-color: #73baff !important;
}

/* force min-width */
.step-items-wrapper {
	width: min-content;
}

.step-item {
	padding: 0.25rem !important;
	/* TODO smaller padding on mobile? */
}

.step-btn {
	background-color: #bad4f2 !important;
	white-space: nowrap;
	min-width: 100px;
}

.header-btn {
	background-color: #b4bac2 !important;
}

.min-content-width {
	width: min-content;
}

.alert {
	margin-bottom: 0 !important;
	padding: 0.375rem 0.75rem !important;
}

.form-row {
	margin: 0 !important;
}

@media only screen and (max-width: 1023px) {
	#app-step {
		padding: 0 10px;
	}

	.app-step-wrapper {
		padding: 0 15px 20px;
	}

	.step-title {
		font-size: 20px;
		line-height: 26px;
	}
}
@media only screen and (max-width: 767px) {
	#app-progress {
		flex: 0 0 auto;
		padding: 0 20px 25px;
	}
}
</style>
